/**
 * IPS Product Term Enum
 * https://github.com/domgen/ips-core-apis-shared/blob/c68dd763bc3cd13b9a50dcbf8f2951d3cdf31fed/src/modules/merchandiseTax/vertexValidation.ts#L5-L9
 */

export enum ProductTerm {
  Subscription = 'Subscription',
  FixedTerm = 'Fixed Term',
  AnnualSubscription = 'Annual Subscription',
}
